import React from "react";
import {Helmet} from "react-helmet";
import { useTranslation } from 'react-i18next';

import { SiteConfig }  from '../SiteConfig';
import HubSpotComponent from '../components/HubSpotComponent';

import ListsGrid from '../components/grids/ListsGrid';

function Lists() {

    const { t } = useTranslation();

    return <div>
            <Helmet bodyAttributes={{ class: 'fill-bg ' + SiteConfig.siteTag }}>
                <title>{t('My Lists')}</title>
            </Helmet>
            <div className="controls">
              <div className="container">
                <div className="col">
                  <h1>{t('My Lists')}</h1>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="col">
                <ListsGrid/>
              </div>
            </div>
            <HubSpotComponent isProductionEnvironment={SiteConfig.isProductionEnvironment}/>
          </div>
}

export default Lists;
